import { KiArbeitet } from '@/components/ki/KiArbeitet'
import { laufFehlerText } from '@/lib/lauf-fehler'
import type { IncomingInvoiceRow, StackReading } from '../types/incoming-invoices.types'

/**
 * AP-34 Nachtrag 4 (PT-18) — **der Stand der KI-Lesung in der Zeile des Eingangsstapels.** Wer zehn Rechnungen
 * ablegt, muss nicht jede öffnen, um zu sehen, wie weit die KI ist: Die Liste sagt, was noch gelesen wird, wo ein
 * Vorschlag wartet und was von Hand zu erfassen bleibt.
 */

/** Die KI ist an dieser Rechnung — sie wartet auf ihren Platz oder liest. */
export const liestNoch = (l: StackReading | null | undefined): boolean => l?.status === 'QUEUED' || l?.status === 'RUNNING'

/** „Stapel mit KI lesen" nimmt, was eine Datei hat und noch nicht gelesen ist — auch, was gescheitert ist. */
export const istZuLesen = (z: Pick<IncomingInvoiceRow, 'hasFile' | 'reading'>): boolean => z.hasFile && (z.reading?.status === 'NONE' || z.reading?.status === 'FAILED')

export function StapelLesung({ lesung }: { lesung: StackReading | null | undefined }) {
  if (!lesung || lesung.status === 'NONE') return <span className="text-muted-foreground">noch nicht gelesen</span>
  if (liestNoch(lesung)) return <KiArbeitet text={lesung.status === 'QUEUED' ? 'wartet auf die KI' : 'KI liest'} className="text-violet-700 dark:text-violet-300" />
  if (lesung.status === 'FAILED') {
    return (
      <span className="text-destructive" title={laufFehlerText(lesung.error) || undefined}>
        Lesung gescheitert
      </span>
    )
  }
  if (lesung.readable === false) return <span className="text-muted-foreground">nicht lesbar — von Hand erfassen</span>
  if (lesung.open) return <span className="inline-flex items-center rounded-full bg-violet-500/15 px-2 py-0.5 text-xs font-medium text-violet-700 dark:text-violet-300">Vorschlag wartet ({lesung.open})</span>
  return <span className="text-muted-foreground">Vorschlag abgearbeitet</span>
}
